import { paths } from './paths';
import { AppNavItem, Credential } from '@shared/types/api';
import NavIcon from './NavIcon';

const navConfig: AppNavItem[] = [
  {
    path: paths.parcels,
    labelKey: 'nav.parcels.main',
    icon: <NavIcon kind="parcel" />,
    isParent: true,
  },
  {
    path: paths.consolidator,
    labelKey: 'nav.consolidate.main',
    icon: <NavIcon kind="consolidate" />,
    isParent: true,
  },
  {
    path: paths.bags,
    labelKey: 'nav.bags.main',
    icon: <NavIcon kind="bag" />,
    isParent: true,
    children: [],
  },
  {
    path: paths.bigs,
    labelKey: 'nav.bigs.main',
    icon: <NavIcon kind="warehouse" />,
    isParent: true,
    children: [],
  },
  {
    path: paths.sortingTapeBags,
    labelKey: 'nav.sortingTapeBags.main',
    icon: <NavIcon kind="scan" />,
    isParent: true,
    children: [],
  },
  {
    path: paths.shipment,
    labelKey: 'nav.shipment.main',
    icon: <NavIcon kind="shipment" />,
    isParent: true,
    children: [],
  },
  {
    path: paths.manifestAcceptance,
    labelKey: 'nav.manifestAcceptance.main',
    icon: <NavIcon kind="manifest" />,
    // access: Credential.manifest,
    isParent: true,
    children: [],
  },
  {
    path: paths.weightCheck,
    labelKey: 'nav.weightCheck.main',
    icon: <NavIcon kind="scales" />,
    isParent: true,
  },
  {
    path: paths.sortingSettings,
    labelKey: 'nav.sortingSettings.main',
    icon: <NavIcon kind="settings" />,
    access: Credential.chuteSettings,
    isParent: true,
    children: [],
  },

  {
    path: paths.labels,
    labelKey: 'nav.labels.main',
    icon: <NavIcon kind="labels" />,
    isParent: true,
    children: [
      {
        path: paths.labelRepair,
        labelKey: 'nav.labelRepair.main',
        icon: <NavIcon kind="qesMail" />,
        accessByCredentialValue: [],
      },
      {
        path: paths.wbBagsLabel,
        labelKey: 'nav.wbBagsLabel.main',
        icon: <NavIcon kind="wbLabel" />,
        accessByCredentialValue: [],
      },
      {
        path: paths.azLabel,
        labelKey: 'nav.azLabel.main',
        icon: <NavIcon kind="azLabel" />,
        accessByCredentialValue: [],
      },
      {
        path: paths.geLabel,
        labelKey: 'nav.geLabel.main',
        icon: <NavIcon kind="geLabel" />,
        accessByCredentialValue: [],
      },
      {
        path: paths.parcelLabel,
        labelKey: 'nav.parcelLabel.main',
        icon: <NavIcon kind="parcelLabel" />,
        accessByCredentialValue: [],
      },
    ],
  },
];

export default navConfig;
